import { useLocation } from 'react-router-dom';

const joinSearch = params =>
  Object.keys(params)
    .reduce((acc, key) => acc.concat(`${key}=${params[key]}`), [])
    .join('&');

const useSearchParams = () => {
  const { search } = useLocation();
  const param = {};
  search.replace(/([^?&]+)=([^?&]+)/g, function(s, v, k) {
    param[v] = decodeURIComponent(k); //解析字符为中文
    return k + '=' + v;
  });
  return [param, joinSearch];
};

export default useSearchParams;
